<template>
  <div class="theme-container">
    <div class="left-container">
      <el-scrollbar class="left-scrollbar-container">
        <p class="theme-title mb10"></p>

        <el-row>
          <el-col :span="24">
            <el-radio-group v-model="enable">
              <el-radio
                class="mb-10"
                style="width: 100%"
                :label="0"
                border
                @change="handleChangeTheme"
                v-removeAriaHidden
              >
                默认外观
              </el-radio>
              <el-radio :label="1" style="width: 100%; margin: 0" border @change="handleChangeTheme" v-removeAriaHidden>
                自定义外观
              </el-radio>
            </el-radio-group>
          </el-col>
          <el-col
            v-if="enable == 1"
            :span="24"
            style="
              margin-top: 10px;
              display: flex;
              justify-content: center;
              align-items: center;
              flex-direction: column;
            "
          >
            <div
              v-for="(item, i) in defineList"
              :key="i"
              :class="{ 'page-type-btn-active': activeDefinePage['pageKey'] === item.pageKey }"
              class="page-type-btn"
              @click="handleClickDefinePage(item)"
            >
              {{ item.pageLabel }}
            </div>
          </el-col>
        </el-row>
        <template v-if="false">
          <el-row :gutter="5">
            <!--          <el-col :span="4">-->
            <!--            <span class="theme-prompt-text">风格</span>-->
            <!--          </el-col>-->
            <!-- 主题分类列表？ -->
            <el-col v-for="item in styleList" :key="item.key" :span="4" :xl="4" :lg="4" :md="8" :sm="8" :xs="10">
              <span
                :class="{ 'style-btn-active': activeStyle === item.key }"
                class="style-btn"
                @click="activeStyleHandle(item)"
                >{{ item.label }}
              </span>
            </el-col>
          </el-row>
          <!-- 主题？ -->
          <el-row :gutter="5">
            <el-col
              v-for="t in themeList"
              :key="t.id"
              :span="8"
              class="theme-img-view"
              @click.native="activeThemeHandle(t)"
            >
              <p :class="{ 'head-list-view-select': activeTheme.id === t.id }" style="height: 100px">
                <el-image
                  :class="{ 'head-list-img-active': activeTheme.id === t.id }"
                  :src="t.headImgUrl"
                  class="head-list-img"
                  fit="cover"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline" />
                  </div>
                </el-image>
              </p>
            </el-col>
          </el-row>
        </template>
      </el-scrollbar>
    </div>
    <pre-view :key="projectFormKey" ref="preViewRef" :form-key="formKey" @hook:mounted="pvMount" />
    <div class="right-container">
      <user-theme v-show="enable === 0" :formKey="formKey" ref="userTheme" @handleChangeFormKey="handleChangeFormKey" />
      <define-theme
        v-show="enable === 1"
        :defineFormThemeProp="defineFormThemeProp"
        :formKey="formKey"
        :activeDefinePage="activeDefinePage.pageKey"
        ref="defineTheme"
        @save="saveSuccessFunc"
      />
    </div>
  </div>
</template>

<script>
import PreView from '../preview'
import { listThemeRequest, saveDefineThemeRequest, getDefineThemeRequest } from '@/api/project/form'
import { listCategory } from '../../../api/project/theme'
import DefineTheme from './components/DefineTheme.vue'
import UserTheme from './components/UserTheme.vue'
import { defineList } from './congif'

export default {
  name: 'Theme',
  components: {
    PreView,
    DefineTheme,
    UserTheme
  },
  data() {
    return {
      enable: 0,
      defineThemeItem: 'start',
      projectFormKey: +new Date(),
      formKey: '',
      styleList: [],
      colorList: ['#FF6D56', '#F8E71C', '#00BF6F', '#2672FF ', '#7464FF', '#484848', '#EAEAEA', '#804000'],
      activeColor: '',
      activeStyle: '',
      activeDefinePage: defineList[0],
      activeTheme: '',
      themeList: [],
      defineList,
      defineFormThemeProp: {}
    }
  },
  mounted() {
    this.formKey = this.$route.query.key
    this.queryFormThemeStyle()
    this.queryFormTheme()
    this.queryDefineFormTheme()
    this.handleChangeFormKey()
  },
  methods: {
    // 获取当前设置的外观详情
    async queryDefineFormTheme() {
      const { data } = await getDefineThemeRequest(this.formKey)
      this.enable = data.defineTheme.enable
      this.$refs.defineTheme.queryFormDefineThemeStyle(data.defineTheme)
      this.$refs.userTheme.queryUserFormTheme(data.userFormTheme)
    },
    handleChangeFormKey() {
      this.projectFormKey = +new Date()
    },
    // 切换默认/自定义外观
    handleChangeTheme() {
      const { enable } = this
      if (this.$refs.defineTheme) {
        this.$refs.defineTheme.defineFormTheme.enable = enable
        this.$refs.defineTheme.handleSaveDefineFormTheme()
        this.handleChangeFormKey()
      }
      this.handleClickDefinePage(this.defineList[0])
    },
    // 选择自定义页面
    handleClickDefinePage(val) {
      this.activeDefinePage = val
      this.setPreviewPage()
    },
    // 预览页与自定义设置页面同步
    setPreviewPage() {
      this.$refs.preViewRef.formConfig.showItem = this.activeDefinePage.pageType
      this.$refs.preViewRef.changeFormConfig()
    },
    saveSuccessFunc() {
      this.handleChangeFormKey()
      this.queryDefineFormTheme()
    },
    pvMount() {
      this.setPreviewPage()
    },
    // 主题列表
    queryFormThemeStyle() {
      listCategory(this.queryParams).then((response) => {
        if (response.data) {
          this.styleList = [{ key: null, label: '全部' }].concat(
            response.data.map((item) => {
              return { key: item.id, label: item.name }
            })
          )
        }
      })
    },
    activeThemeHandle(item) {
      if (item) {
        this.$confirm('切换主题，系统将不会保存您在上一主题所做的修改，请知悉。', '切换主题提醒', {
          confirmButtonText: '确定',
          cancelButtonText: '取消操作',
          type: 'info'
        })
          .then(() => {
            this.activeTheme = item
            this.saveUserTheme(item)
          })
          .catch(() => {})
      }
    },
    activeColorHandle(item) {
      this.activeColor = item
      this.queryFormTheme()
    },
    queryFormTheme() {
      listThemeRequest({
        color: this.activeColor,
        style: this.activeStyle
      }).then((res) => {
        this.themeList = res.data
      })
    }
  }
}
</script>

<style scoped>
.theme-container {
  width: 100%;
  height: 100%;
  background-color: #f7f7f7;
  overflow: hidden;
  display: flex;
  box-sizing: border-box;
}

.left-container {
  line-height: 20px;
  text-align: center;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 100);
  background-color: white;
  width: 320px;
  height: 100%;
  padding: 10px;
}

.left-scrollbar-container {
  height: 100%;
}

::v-deep .el-scrollbar__wrap {
  overflow-x: hidden !important;
}

.style-btn {
  line-height: 23px;
  border-radius: 4px;
  padding: 3px;
  color: #707070;
  font-size: 14px;
  height: 30px;
  text-align: center;
  border: 1px solid #eaeaea;
  display: inline-block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.theme-title {
  color: rgba(16, 16, 16, 100);
  font-size: 18px;
  font-weight: bold;
  text-align: left;
}

.theme-prompt-text {
  color: rgba(16, 16, 16, 100);
  font-size: 16px;
  line-height: 30px;
  text-align: left;
}

.color-btn {
  width: 40px;
  height: 22px;
  line-height: 20px;
  border-radius: 4px;
  background-color: rgba(11, 141, 213, 100);
  color: rgba(16, 16, 16, 100);
  font-size: 14px;
  text-align: center;
  margin: 3px;
  border: 1px solid rgba(255, 255, 255, 100);
}

.color-btn:hover,
.style-btn:hover {
  cursor: pointer;
  border: 1px solid rgba(11, 141, 213, 100);
}

.style-btn-active {
  border: 1px solid rgba(11, 141, 213, 100);
}

.page-type-btn {
  width: 75px;
  line-height: 30px;
  height: 30px;
  border-radius: 4px;
  font-size: 12px;
  margin: 3px;
  border: 1px solid #dcdfe6;
}
.page-type-btn:hover {
  border-color: #409eff;
}
.page-type-btn-active {
  color: #fff;
  border-color: #409eff;
  background-color: #409eff;
}

.head-list-img {
  border: 2px solid transparent;
  height: 100%;
}

.head-list-img:hover {
  cursor: pointer;
  border: 2px solid rgba(11, 141, 213, 100);
}

.head-list-img-active {
  border: 2px solid rgba(11, 141, 213, 100);
}

.theme-img-view .head-list-view-select ::after {
  content: '';
  background: url('~@/assets/images/mobile_theme_active.png');
  background-size: 18px;
  width: 18px;
  height: 18px;
  position: absolute;
  top: 4px;
  right: 4px;
}

.right-container {
  width: 420px;
  height: 100%;
  line-height: 20px;
  padding: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 100);
  background-color: white;
  overflow: auto;
}
.right-title {
  display: inline-block;
  color: rgba(16, 16, 16, 100);
  font-size: 18px;
  text-align: left;
  font-weight: bold;
  margin: 0 0 30px 0;
}
.el-radio {
  margin-right: 0px;
}
</style>
